/* Header personalizado — interactividad
   - No sobrescribe window.fetch
   - Se re-inicializa en el editor de temas (shopify:section:load)
   - Dropdown accesible por teclado (el CSS abre con :hover / :focus-within;
     este JS agrega la intencion de hover con retardo y el soporte tactil) */

(function () {
  'use strict';

  var HOVER_CLOSE_DELAY = 150;
  var DESKTOP_MIN = 990;

  function isDesktop() {
    return window.innerWidth >= DESKTOP_MIN;
  }

  /* ---------- 1. MENU DE ESCRITORIO ---------- */
  function initDesktopMenu(root) {
    var items = root.querySelectorAll('.th-has-dropdown');
    if (!items.length) return;

    var closeTimer = null;

    function setExpanded(item, value) {
      var link = item.querySelector('.th-menu-link');
      if (link) link.setAttribute('aria-expanded', value ? 'true' : 'false');
    }

    function closeAll() {
      for (var i = 0; i < items.length; i++) {
        items[i].classList.remove('is-hovered');
        setExpanded(items[i], false);
      }
    }

    function open(item) {
      clearTimeout(closeTimer);
      closeAll();
      item.classList.add('is-hovered');
      setExpanded(item, true);
    }

    function scheduleClose(item) {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        item.classList.remove('is-hovered');
        setExpanded(item, false);
      }, HOVER_CLOSE_DELAY);
    }

    Array.prototype.forEach.call(items, function (item) {
      var panel = item.querySelector('.th-dropdown-panel');
      var link = item.querySelector('.th-menu-link');

      item.addEventListener('mouseenter', function () {
        if (isDesktop()) open(item);
      });
      item.addEventListener('mouseleave', function () {
        if (isDesktop()) scheduleClose(item);
      });

      if (panel) {
        panel.addEventListener('mouseenter', function () {
          clearTimeout(closeTimer);
        });
        panel.addEventListener('mouseleave', function () {
          if (isDesktop()) scheduleClose(item);
        });
      }

      /* Tactil: el primer toque abre, el segundo navega.
         Con mouse real el clic navega siempre (no se bloquea). */
      if (link) {
        link.addEventListener('click', function (e) {
          var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
          if (finePointer || !isDesktop()) return;
          if (!item.classList.contains('is-hovered')) {
            e.preventDefault();
            open(item);
          }
        });
      }
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.th-has-dropdown')) closeAll();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }

  /* ---------- 2. DRAWER MOVIL ---------- */
  var drawerBound = false;

  function initMobileDrawer() {
    if (drawerBound) return;
    drawerBound = true;

    function parts() {
      return {
        drawer: document.querySelector('.th-mobile-drawer'),
        overlay: document.querySelector('.th-drawer-overlay'),
        button: document.querySelector('#thTopMobileMenuBtn')
      };
    }

    function openDrawer() {
      var p = parts();
      if (!p.drawer || !p.overlay) return;
      p.drawer.classList.add('is-active');
      p.overlay.classList.add('is-active');
      document.body.classList.add('th-scroll-locked');
      if (p.button) p.button.setAttribute('aria-expanded', 'true');
      var first = p.drawer.querySelector('.th-drawer-close');
      if (first) first.focus();
    }

    function closeDrawer() {
      var p = parts();
      if (!p.drawer || !p.overlay) return;
      p.drawer.classList.remove('is-active');
      p.overlay.classList.remove('is-active');
      document.body.classList.remove('th-scroll-locked');
      if (p.button) {
        p.button.setAttribute('aria-expanded', 'false');
        p.button.focus();
      }
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('#thTopMobileMenuBtn')) {
        openDrawer();
        return;
      }
      if (e.target.closest('.th-drawer-close') ||
          e.target.classList.contains('th-drawer-overlay')) {
        closeDrawer();
        return;
      }

      /* Acordeon: solo la flecha abre/cierra. El texto del link navega. */
      var chevron = e.target.closest('.th-m-icon-wrap');
      if (!chevron) return;
      e.preventDefault();
      var li = chevron.closest('.th-m-nav-item');
      if (!li) return;
      var wasOpen = li.classList.contains('is-open');
      var opened = document.querySelectorAll('.th-m-nav-item.is-open');
      for (var i = 0; i < opened.length; i++) {
        if (opened[i] !== li) {
          opened[i].classList.remove('is-open');
          var other = opened[i].querySelector('.th-m-icon-wrap');
          if (other) other.setAttribute('aria-expanded', 'false');
        }
      }
      li.classList.toggle('is-open', !wasOpen);
      chevron.setAttribute('aria-expanded', wasOpen ? 'false' : 'true');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var d = document.querySelector('.th-mobile-drawer');
      if (d && d.classList.contains('is-active')) closeDrawer();
    });
  }

  /* ---------- 3. CARRITO ---------- */
  var cartBound = false;

  function paintCount(count) {
    var badges = document.querySelectorAll('.th-cart-count');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = count < 100 ? count : '99+';
      badges[i].setAttribute('data-cart-count', count);
      badges[i].classList.remove('th-bump');
      void badges[i].offsetWidth; /* fuerza reinicio de la animacion */
      badges[i].classList.add('th-bump');
    }
  }

  function refreshCount() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { paintCount(cart.item_count); })
      .catch(function () {});
  }

  function initCart() {
    /* Abrir el cart drawer nativo si el tema lo tiene */
    var links = document.querySelectorAll('.th-cart-link');
    Array.prototype.forEach.call(links, function (link) {
      if (link.dataset.thCartBound) return;
      link.dataset.thCartBound = '1';
      link.addEventListener('click', function (e) {
        var cd = document.querySelector('cart-drawer');
        if (cd && typeof cd.open === 'function') {
          e.preventDefault();
          cd.open();
        }
      });
    });

    if (cartBound) return;
    cartBound = true;

    /* Via nativa de Dawn: pubsub. Nada de parchar window.fetch. */
    if (typeof window.subscribe === 'function' &&
        window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refreshCount);
      return;
    }

    /* Respaldo si el tema no expone pubsub */
    document.addEventListener('cart:refresh', refreshCount);
    document.addEventListener('submit', function (e) {
      var action = e.target && e.target.getAttribute('action');
      if (action && action.indexOf('/cart/add') !== -1) {
        setTimeout(refreshCount, 600);
      }
    });
  }

  /* ---------- ARRANQUE ---------- */
  function boot() {
    var header = document.querySelector('.th-header-wrapper');
    if (!header) return;
    initDesktopMenu(header);
    initMobileDrawer();
    initCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Editor de temas: la seccion se re-renderiza y hay que reenganchar */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('.th-header-wrapper')) {
      drawerBound = false;
      boot();
    }
  });
})();
